<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
    :class="{ 'border-b border-black': withBorder }"
  >
    <section
      class="w-full flex flex-col lg:flex-row lg:justify-center items-center px-6 lg:px-0 pt-10 pb-7 lg:pt-12 lg:pb-4 col-span-full md:col-start-2 md:col-end-8 lg:col-end-12 gap-x-10 gap-y-6"
    >
      <section class="w-full lg:w-1/2">
        <p
          class="text-10 leading-11.5"
          v-text="'Agregar título de banner segun la Temática'"
        />
        <p
          class="pt-8 text-xl"
          v-text="
            'Lorem Ipsum is simply dzummy textof the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five.'
          "
        />
      </section>

      <section class="w-full lg:w-1/2">
       <section class="h-86.5 w-full bg-gray-400"/>
      </section>
    </section>
  </section>
</template>
<script>
export default {
  props:{
    withBorder:{
      default: true
    }
  }
};
</script>
